import { pickAll } from "lodash/fp";
import { useContext } from "react";

import {
  Icon,
  Button,
  useThemeProps,
  handleComponentsProp,
} from "../../wsui/base";

import postsModuleContext from "./postsModuleContext";

const DefaultButton = Button;

export default function PostsModuleButtonItem(props) {
  props = useThemeProps({ props, name: "MunicipioPostsModuleButtonItem" });
  let {
    item,
    visibleFields,
    components = {},
    width,
    iconProps = {},
    ...restProps
  } = props;

  let { Button } = handleComponentsProp(components, { Button: DefaultButton });

  let link = item?.link;
  let icon = item?.icon;

  item = pickAll(visibleFields, item);

  const { itemColor } = useContext(postsModuleContext);

  return (
    <Button
      color={itemColor}
      href={link?.url}
      width={width}
      variant="shortcut"
      {...restProps}
    >
      {!!icon && <Icon name={icon} size="1.5em" {...iconProps} />}
      {item.title}
    </Button>
  );
}
